<div class="container-fluid">
  <div class="row justify-content-md-center my-2">
    <h3>
      Gestione Veicoli <small>Parco {{ parkName }}</small>
    </h3>
  </div>
  <div class="row mt-5">
    <div class="col-8">
      <button
        class="btn btn-primary"
        (click)="openAddVehicleModal(addVehicleTemplate)"
      >
        Crea nuovo veicolo
      </button>
    </div>
    <div class="col-4">
      <mat-form-field class="vehicle-search-input">
        <mat-label>Cerca targa</mat-label>
        <input
          matInput
          (input)="applyVehicleSearchFilter($event.target.value)"
          placeholder="Eg. CRI001"
          #input
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row justify-content-md-center mb-5">
    <div class="col">
      <table
        mat-table
        [dataSource]="vehiclesTableDataSource"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>
        <ng-container matColumnDef="plate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Targa</th>
          <td mat-cell *matCellDef="let element">{{ element.plate }}</td>
        </ng-container>
        <ng-container matColumnDef="closed_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Stato</th>
          <td mat-cell *matCellDef="let element">
            {{ element.closed_at ? "Sospeso" : "Attivo" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="modelName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Modello</th>
          <td mat-cell *matCellDef="let element">{{ element.modelName }}</td>
        </ng-container>
        <ng-container matColumnDef="modelBrandName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Marca</th>
          <td mat-cell *matCellDef="let element">
            {{ element.modelBrandName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="typeSupertypeName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Classe</th>
          <td mat-cell *matCellDef="let element">
            {{ element.typeSupertypeName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="typeName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sottoclasse</th>
          <td mat-cell *matCellDef="let element">
            {{ element.typeName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="km">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Km totale</th>
          <td mat-cell *matCellDef="let element">
            {{ element.chilometri_totali ?? "0" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              aria-label="Edit item"
              (click)="onVehicleRowActionHandler(element)"
            >
              <mat-icon>settings</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="vehicleDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: vehicleDisplayedColumns"></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[50, 100, 250]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</div>

<ng-template #addVehicleTemplate>
  <div class="modal-header">
    <h5 class="modal-title pull-left">
      Compila questi campi per creare un nuovo veicolo
    </h5>
    <button
      type="button"
      class="close btn-close pull-right"
      aria-label="Close"
      (click)="addVehicleModalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Targa CRI</span>
          </div>
          <input
            type="text"
            formControlName="targa"
            class="form-control"
            [class.is-invalid]="submitted && cp.targa.errors"
          />
          <div class="width-100per">
            <div><strong>Non inserire 'CRI' nella targa</strong></div>
          </div>
          <div *ngIf="submitted && cp.targa.errors" class="invalid-feedback">
            <div *ngIf="cp.targa.errors.required">
              la targa è un campo obbligatorio
            </div>
            <div *ngIf="cp.targa.errors.minlength">Targa troppo corta</div>
            <div *ngIf="cp.targa.errors.maxlength">Targa troppo lunga</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Marca veicolo</span>
          </div>
          <input
            type="text"
            class="form-control"
            formControlName="marcaText"
            (input)="onMarcaChanged(marcaInput.value)"
            #marcaInput
          />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Modello veicolo</span>
          </div>
          <input
            type="text"
            class="form-control"
            formControlName="modelloText"
            (input)="onModelloChanged(modelloInput.value)"
            #modelloInput
          />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <ul
            class="list-group mb-3 width-100per"
            [hidden]="models.length == 0"
          >
            <li
              class="list-group-item"
              style="font-size: 10px; padding: 10px"
              *ngFor="let model of models"
              [class.active]="cp.modello.value === model.id"
              (click)="modelloSelected(model)"
            >
              {{ model.brand.name }} - {{ model.name }}
            </li>
          </ul>
          <div
            *ngIf="submitted && cp.modello.errors"
            class="width-100per my-invalid-feedback"
          >
            <div *ngIf="cp.modello.errors.required">Specificare modello</div>
            <div *ngIf="cp.modello.errors.min">Modello invalido</div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Classe veicolo</span>
          </div>
          <input
            type="text"
            class="form-control"
            formControlName="classeText"
            (input)="onClasseChanged(classeInput.value)"
            #classeInput
          />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Sottoclasse veicolo</span>
          </div>
          <input
            type="text"
            class="form-control"
            formControlName="sottoclasseText"
            (input)="onSottoclasseChanged(sottoclasseInput.value)"
            #sottoclasseInput
          />
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <ul
            class="list-group mb-3 width-100per"
            [hidden]="classes.length == 0"
          >
            <li
              class="list-group-item"
              style="font-size: 10px; padding: 10px"
              *ngFor="let class of classes"
              [class.active]="cp.tipo.value === class.id"
              (click)="classeSelected(class)"
            >
              {{ class.supertype.name }} - {{ class.name }}
            </li>
          </ul>
          <div
            *ngIf="submitted && cp.tipo.errors"
            class="width-100per my-invalid-feedback"
          >
            <div *ngIf="cp.tipo.errors.required">Specificare classe</div>
            <div *ngIf="cp.tipo.errors.min">Classe invalida</div>
          </div>
        </div>
      </div>
      <div *ngIf="errorMessage" class="alert alert-danger my-3">
        {{ errorMessage }}
      </div>
      <button [disabled]="loading" class="btn btn-primary">
        <span
          *ngIf="loading"
          class="spinner-border spinner-border-sm mr-1"
        ></span>
        Crea veicolo
      </button>
    </form>
  </div>
</ng-template>
